import React from 'react';
import { doc, setDoc, Timestamp, collection } from 'firebase/firestore';
import { db } from '../firebase';
import { Card } from '../components/UI';
import PertumbuhanForm from '../components/assessment/PertumbuhanForm';
import KpspForm from '../components/assessment/KpspForm';
import MentalForm from '../components/assessment/MentalForm';
import { GpphForm, ChatForm } from '../components/assessment/SpecializedForms';
import TddForm from '../components/assessment/TddForm';
import MataForm from '../components/assessment/MataForm';
import { calculateAgeMonths } from '../helpers/utils';

export default function SingleAssessmentScreen({ user, child, type, navigate, showToast }) {
    const assessmentTitles = {
        pertumbuhan: 'Deteksi Pertumbuhan',
        kpsp: 'Deteksi Perkembangan (KPSP)',
        mental: 'Deteksi Mental Emosional (KMME)',
        tdd: 'Tes Daya Dengar (TDD)',
        tdl: 'Pemeriksaan Mata',
        chat: 'Skrining Autisme (CHAT)',
        gpph: 'Skrining GPPH',
    };

    const handleSave = async (data, status) => {
        if (user.isAnonymous) {
            // For guest users, just show results without saving
            const newAssessmentData = {
                ...data,
                type: type,
                overallStatus: status || data.pertumbuhan?.status || data.perkembangan?.status || data.mental?.status || 'Selesai',
                createdAt: Timestamp.now(),
                ageInMonths: calculateAgeMonths(child.dob.toDate()),
                childName: child.name,
                childDob: child.dob,
                id: 'demo-assessment'
            };

            showToast('Hasil pemeriksaan siap ditampilkan (Mode Demo - tidak disimpan)!', 'info');
            navigate('results', child, newAssessmentData);
            return;
        }

        try {
            const assessmentsPath = `children/${child.id}/assessments`;
            const newAssessmentRef = doc(collection(db, assessmentsPath));
            
            const newAssessmentData = {
                ...data,
                type: type,
                overallStatus: status || data.pertumbuhan?.status || data.perkembangan?.status || data.mental?.status || 'Selesai',
                createdAt: Timestamp.now(),
                ageInMonths: calculateAgeMonths(child.dob.toDate()),
                childName: child.name,
                childDob: child.dob,
                assessorUid: user.uid
            };

            await setDoc(newAssessmentRef, newAssessmentData);

            // Update the child document with the last assessment
            const childDocRef = doc(db, `children/${child.id}`);
            await setDoc(childDocRef, {
                lastAssessment: {
                    type: newAssessmentData.type,
                    overallStatus: newAssessmentData.overallStatus,
                    createdAt: newAssessmentData.createdAt
                }
            }, { merge: true });

            showToast('Data berhasil disimpan!');
            navigate('viewChild', child);

        } catch (error) {
            console.error("Error saving assessment:", error);
            showToast("Gagal menyimpan data.", "error");
        }
    };

    const renderForm = () => {
        switch(type) {
            case 'pertumbuhan': return <PertumbuhanForm onSave={handleSave} child={child} />;
            case 'kpsp': return <KpspForm child={child} onSave={handleSave} />;
            case 'mental': return <MentalForm child={child} onSave={handleSave} />;
            case 'tdd': return <TddForm child={child} onSave={handleSave} />;
            case 'tdl': return <MataForm child={child} onSave={handleSave} />;
            case 'chat': return <ChatForm child={child} onSave={handleSave} />;
            case 'gpph': return <GpphForm child={child} onSave={handleSave} />;
            default: return <p>Jenis pemeriksaan tidak valid.</p>;
        }
    };

    return (
        <div className="pb-24">
            <Card>
                <h2 className="text-2xl font-bold text-brand-dark mb-1">{assessmentTitles[type] || 'Pemeriksaan'}</h2>
                <p className="text-brand-muted mb-6">Untuk anak: <span className="font-semibold">{child.name}</span></p>
                {renderForm()}
            </Card>
        </div>
    );
}
